import { type ProductName_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';

const COVERABLE_CODE = {
    dog: 'topdanmark_dog',
    cat: 'topdanmark_cat',
    kennel: 'topdanmark_kennel',
    accident: 'top_acc_accident',
    childAccident: 'top_acc_child',
    youngAccident: 'top_acc_young',
    crossAccident: 'top_acc_cross',
    privateContent: 'top_prc_content',
    youthContent: 'top_prc_youth_content',
    travelHousehold: 'top_tra_household',
    travelIndividual: 'top_tra_individual',
    stc: 'STCSingleTripCancellationInsurance',
    stt: 'STTSingleTripTravelInsurance',
    car: 'top_mvp_car'
} as const;

const FLAVOUR_NAME_MAP: Record<ProductName_Top, string> = {
    top_acc_accident: 'ulykkesforsikring',
    top_acc_child: 'børneforsikring',
    top_tra_individual: 'rejseforsikring til enkeltperson',
    top_tra_household: 'rejseforsikring',
    top_prc_content: 'indboforsikring',
    topdanmark_cat: 'katteforsikring',
    topdanmark_dog: 'hundeforsikring',
    topdanmark_kennel: 'kennelforsikring',
    top_acc_young: 'ulykkesforsikring til unge',
    top_prc_youth_content: 'indboforsikring til unge',
    STCSingleTripCancellationInsurance: 'afbestillingsforsikring til enkeltrejse',
    STTSingleTripTravelInsurance: 'enkeltrejseforsikring',
    top_mvp_car: 'bilforsikring'
};

const DETAILS_PAGE_FLAVOUR_URL: Record<ProductName_Top, string> = {
    top_acc_accident: 'ulykkesforsikring',
    top_acc_child: 'børneforsikring',
    top_tra_individual: 'rejseforsikring',
    top_tra_household: 'rejseforsikring',
    top_prc_content: 'indboforsikring',
    topdanmark_cat: 'katteforsikring',
    topdanmark_dog: 'hundeforsikring',
    topdanmark_kennel: 'kennelforsikring',
    top_acc_young: 'ulykkesforsikring-til-unge',
    top_prc_youth_content: 'indboforsikring-til-unge',
    STCSingleTripCancellationInsurance: 'afbestillingsforsikring-til-enkeltrejse',
    STTSingleTripTravelInsurance: 'enkeltrejseforsikring',
    top_mvp_car: 'bilforsikring'
};

export { COVERABLE_CODE, FLAVOUR_NAME_MAP, DETAILS_PAGE_FLAVOUR_URL };
